import React from "react";

import { ReactComponent as IconSms } from "../../../../build/images/nps-dashboard-icons/icon-sms.svg";
import { ReactComponent as IconEmail } from "../../../../build/images/nps-dashboard-icons/icon-email.svg";
import { ReactComponent as IconVoice } from "../../../../build/images/nps-dashboard-icons/icon-voice.svg";
import { ReactComponent as IconRcs } from "../../../../build/images/nps-dashboard-icons/icon-rcs.svg";
import { ReactComponent as IconWhatsapp } from "../../../../build/images/nps-dashboard-icons/icon-whatsapp.svg";
import { ReactComponent as IconInstagram } from "../../../../build/images/instagram_new.svg";
import { ReactComponent as IconWebchat } from "../../../../build/images/webchat-new.svg";
import { ReactComponent as IconFacebook } from "../../../../build/images/facebook_new.svg";
import { ReactComponent as IconTelegram } from "../../../../build/images/telegram-new.svg";
import { ReactComponent as IconTwitter } from "../../../../build/images/twitter-new.svg";
import { ReactComponent as IconLinkedin } from "../../../../build/images/linkedin-new.svg";
import { ReactComponent as IconGbm } from "../../../../build/images/googlegbm-new.svg";
import { ReactComponent as TEAMS } from "../../../../build/images/channels/teamsMedium.svg";

import "./card-channel-based.styles.css";

const CardChannelBased = ({
  midiaId,
  sent,
  answered,
  all,
  enviadas,
  iniciadas,
  completadas,
}) => {
  function renderIconByMidaId(id) {
    switch (id) {
      case 1:
        return <IconVoice />;
      case 2:
        return <IconWebchat />;
      case 3:
        return <IconEmail />;
      case 4:
        return <IconFacebook />;
      case 5:
        return <IconWhatsapp />;
      case 6:
        return <IconInstagram />;
      case 8:
        return <IconTelegram />;
      case 9:
        return <IconTwitter />;
      case 10:
        return <IconLinkedin />;
      case 11:
        return <IconGbm />;
      case 12:
        return <IconSms />;
      case 15:
        return <TEAMS />;
      default:
        return null;
    }
  }
  return (
    <div className="card-channel-based">
      <div
        className="card-channel-based__icon"
        style={{ width: "40px", height: "40px" }}
      >
        {renderIconByMidaId(midiaId)}
      </div>
      <div className="card-channel-based__values">
        <div className="card-channel-based__values__item">
          <div className="card-channel-based__values__item__number">
            {enviadas}
          </div>
          <span className="card-channel-based__values__item__text">
            Enviadas
          </span>
        </div>
        <div className="card-channel-based__values__item">
          <div className="card-channel-based__values__item__number">
            {iniciadas}
          </div>
          <span className="card-channel-based__values__item__text">
            Iniciadas
          </span>
        </div>
        <div className="card-channel-based__values__item">
          <div className="card-channel-based__values__item__number">
            {completadas}
          </div>
          <span className="card-channel-based__values__item__text">
            Completadas
          </span>
        </div>
      </div>
    </div>
  );
};

export default CardChannelBased;
